const TLD1 = [
  'AC',
  'ACADEMY',
  'AD',
  'AG',
  'AGENCY',
  'AI',
  'AM',
  'ANALYTICS',
  'ANDROID',
  'AOL',
  'APARTMENTS',
  'APP',
  'APPLE',
  'AR',
  'AS',
  'ASIA',
  'AT',
  'AU',
  'AWS',
  'AZURE',
  'BA',
  'BAIDU',
  'BANK',
  'BB',
  'BBC',
  'BBT',
  'BBVA',
  'BEAUTY',
  'BET',
  'BG',
  'BI',
  'BIZ',
  'BID',
  'BING',
  'BLOG',
  'BM',
  'BN',
  'BO',
  'BOOKING',
  'BOT',
  'BOUTIQUE',
  'BR',
  'BS',
  'BT',
  'BUY',
  'CA',
  'CAB',
  'CAFE',
  'CAL',
  'CALL',
  'CAMERA',
  'CBA',
  'CBS',
  'CC',
  'CF',
  'CHANNEL',
  'CHAT',
  'CLOUD',
  'CLUB',
  'CM',
  'CN',
  'CO',
  'COM',
  'CPA',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DEV',
  'DHL',
  'DZ',
  'EC',
  'ECO',
  'EDU',
  'EG',
  'ES',
  'ET',
  'EU',
  'FR',
  'GOV',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'IBM',
  'ID',
  'IE',
  'IN',
  'INC',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'LA',
  'LT',
  'LTD',
  'LU',
  'LISTING',
  'LUXURY',
  'MEDIA',
  'MEN',
  'MENU',
  'MICROSOFT',
  'MINT',
  'MOBILE',
  'MS',
  'NA',
  'NC',
  'NE',
  'NET',
  'NEW',
  'NEWS',
  'NHK',
  'NOKIA',
  'NZ',
  'ONE',
  'ONLINE',
  'OPEN',
  'ORG',
  'PAGE',
  'PAY',
  'PY',
  'QA',
  'RENT',
  'RENTALS',
  'RSVP',
  'RU',
  'SAVE',
  'SKIN',
  'SOCIAL',
  'SOFTWARE',
  'SOLUTIONS',
  'SPACE',
  'TAXI',
  'TC',
  'TECH',
  'TN',
  'TO',
  'TRADE',
  'TV',
  'TVS',
  'UK',
  'UNIVERSITY',
  'US',
  'VENTURES',
  'VIDEO',
  'VISA',
  'YAHOO',
  'YANDEX',
  'YE',
  'YOUTUBE',
  'YT',
  'ZM',
  'ZW'
]

export { TLD1 }
